module.exports = __webpack_public_path__ + "static/media/zBTC.da2136fc.png";